var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{class:_vm.chartContainerClassContent},[_c('div',{ref:"chart",staticClass:"chart--content"}),_vm._v(" "),_c('figcaption',[_c('chart-legend',{attrs:{"school-legend":_vm.legendItems,"type":_vm.type}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }